import { onError } from '@apollo/client/link/error';

export const handleGraphQLErrors = (
  errors: any,
  signOut: () => void
) => {

  for (let err of errors) {
    switch (err?.extensions?.code) {
      case 'UNAUTHENTICATED':
        signOut();
        window.location.href = '/login';
        window.location.reload();
        return;
      default:
        return;
    }
  }
}

export const errorLink = (signOut: () => void) =>
  onError(({ graphQLErrors, networkError }): any => {
    if (graphQLErrors) {
      return handleGraphQLErrors(graphQLErrors, signOut);
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }
  });
